"use strict";
// An event to be fired when scripts are loaded
(function () {
    // Create the event.
    var event = new Event('ScriptsLoaded', { bubbles: true, cancelable: true });
    // Fire targeting document Element or other EventTarget.
    document.dispatchEvent(event);
}());